import React, { useState } from 'react';
import { Button, CssBaseline, Typography, Box, Container, Divider, Card, CardContent, Grid, CircularProgress, InputAdornment, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import googleicon from '../assets/images/google.svg';
import { BaseAPI } from '../utils/Api';
import { FormProvider, RHFTextField } from '../components/hook-form';
import { RegisterSchema } from '../utils/SchemaValidation';
import { setItem } from '../utils/Helper';
import Notification from '../utils/Notification';

const Registration = () => {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const defaultValues = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    password: '',
  };

  const methods = useForm({
    resolver: yupResolver(RegisterSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    const body = {
      f_name: data.firstName,
      l_name: data.lastName,
      email: data.email,
      phone: data.phoneNumber,
      password: data.password,
    };
    console.log(body);
    await BaseAPI.post('/auth/signup', body)
      .then((res) => {
        if (res.data.status === 'ok') navigate('/verify-otp');

        setItem(localStorage, 'e', data.email);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          Notification(err?.response?.data?.message, 'error');
        } else {
          Notification('Please check your internet connection', 'error');
        }
      })
      .finally(() => reset());
  };

  return (
    <Container component='main' maxWidth='sm' sx={{ height: '90vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CssBaseline />
      <Card>
        <CardContent>
          <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Button size='large' fullWidth color='primary' sx={{ bgcolor: '#E3F1FF' }}>
              <img src={googleicon} alt='google icon' height='20px' width='20px' style={{ marginRight: '1em' }} />
              Sign In with Google
            </Button>

            <Box my={4}>
              <Divider component='hr'></Divider>
            </Box>

            <Box display='flex' justifyContent='center'>
              <Typography variant='subtitle1'>Sign In With Email Address</Typography>
            </Box>

            <RHFTextField name='firstName' label='First name' />
            <RHFTextField name='lastName' label='Last Name' />
            <RHFTextField name='phoneNumber' label='Phone Number' />
            <RHFTextField name='email' label='Email' />
            <RHFTextField
              name='password'
              label='Password'
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton aria-label='toggle password visibility' onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button type='submit' fullWidth variant='contained' disableElevation color='primary' disabled={isSubmitting} sx={{ mt: 4 }}>
              {isSubmitting ? <CircularProgress size={24} color='primary' /> : 'Sign Up'}
            </Button>
            <Grid container mt={2}>
              <Grid item xs>
                <Button variant='text' color='primary' component={Link} to='/forgot-password'>
                  Forgot password?
                </Button>
              </Grid>
              <Grid item>
                <Button variant='text' color='primary' component={Link} to='/login'>
                  I already have an account.
                </Button>
              </Grid>
            </Grid>
          </FormProvider>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Registration;
